import { motion } from 'framer-motion';
import React from 'react';

import { cn } from './cn';

export interface LinkButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

/**
 * A clickable link-style button area with a top border and gradient fade,
 * commonly used for "Show all...", "Load more..." actions at the bottom of widgets.
 */
export const LinkButton = React.forwardRef<HTMLDivElement, LinkButtonProps>(
  ({ children, className, onClick, ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        className={cn(
          'flex cursor-pointer justify-center rounded-b-lg border-t border-border bg-gradient-to-t from-transparent to-surface/90 px-4 py-4 text-sm text-gray-500 transition-colors duration-200 hover:border-primary-500 hover:text-text-primary',
          className
        )}
        onClick={onClick}
        whileHover={{ y: -1 }}
        transition={{ type: 'spring', stiffness: 400, damping: 25 }}
        {...(props as any)}
      >
        {children}
      </motion.div>
    );
  }
);
LinkButton.displayName = 'LinkButton';
